import React from 'react';
import { Alert } from '@gcc/autobahn-components';
import { MessageContainerDiv } from './styles';

const ErrorMessage = message => <MessageContainerDiv><Alert showIcon text={message} type="error" /></MessageContainerDiv>;

export default ErrorMessage;
